import axios from "axios";
import * as _ from "lodash";
import getConfig from "next/config";
import publicIp from "public-ip";
import { get, getBsp, getEndpoints, post, postBsp, postEndpoints, putBsp, deleteBsp } from "./request";
import { formatCompanyTypes, formatInfoMandate, productsFilterByProfile } from "../mappers";
import { GREEN_PRODUCT, GREY_PRODUCT, mandateInfo } from "../constants";

const envConfig = getConfig();

const getCurrentIp = async () => {
	// eslint-disable-next-line valid-typeof
	if (typeof window !== undefined) {
		try {
			return await publicIp.v4();
		} catch (error) {
			return "IP not Detected";
		}
	} else {
		return "IP not Detected";
	}
};

const getCustomerLanguage = async () =>
	get(`/`, {}).then((result: any) => {
		if (result.ok) {
			const resp = result.data.Response;

			return {
				...result,
				data: resp
			};
		}
		return result;
	});

const getMandateInfo = async (energy: string) =>
	get(`/GetMandateNumber`, {
		params: {
			Nrj: energy
		}
	}).then((result: any) => {
		if (result.ok) {
			const resp = result.data;

			//console.log("getMandateInfo resp", resp);

			return {
				...result,
				data: formatInfoMandate(
					{
						...mandateInfo,
						...resp
					},
					energy
				)
			};
		}

		return {
			...result
		};
	});

const createContractEG = async (requestData: any) =>
	post(`/storewebprospecteg`, {
		data: requestData
	}).then((result: any) => {
		if (result.ok) {
			const resp = result;

			//console.log("resp", resp);
		}

		return result;
	});

const getSubscriptionId = async (canalId: string) =>
	// TODO Check Canal param if correct.
	get(`/GetLandingPage?Canal=${canalId}`, {}).then((result: any) => {
		if (result.ok) {
			const resp = result;

			//console.log("resp", resp);
		}

		return result;
	});

const getCompanyTypes = async () =>
	get(`/GetCompanyTypes`, {}).then((result: any) => {
		if (result.ok) {
			const resp = result.data;

			//console.log("getCompanyTypes result", result);

			return {
				...result,
				data: formatCompanyTypes(resp)
			};
		}

		return result;
	});

const getGeneralConditions = async (isPro: number, language: string) =>
	get(`/getconditions/${!isPro ? "R" : "P"}/${language}`, {}).then(
		(result: any) => {
			if (result.ok) {
				const resp = result.data;

				//console.log("getGeneralConditions result", result);

				return {
					...result,
					data: resp
				};
			}

			return result;
		}
	);

export const getFunnelProperties = (params: any) =>
	get(`/GetFunnelProperties`, { params }).then((result: any) => {
		if (result.ok) {
			const resp = result.data;

			return {
				...result,
				data: resp
			};
		}
		return result;
	});

/* TODO New Params?
SalesGeneratorDotNet=
AgentDotNet=
TypeClientDotNet=
DurationDotNet=
swDotNet=false
WebReference=GotoSatV
SingleElecProduct=
SingleGazProduct=
SingleSouscriptionDate=
 */
/*
		{
			params: {
				...params,
				swDotNet: false,
				AgentDotNet: "",
				TypeClientDotNet: "",
				DurationDotNet: "",
				WebReference: "GotoSatV",
				SingleElecProduct: "",
				SingleGazProduct: "",
				SingleSouscriptionDate: ""
			}
		}
 */
export const startSimulation = (params: any) =>
	get(`/SimulationOfAllProductsM6`, { params }).then((result: any) => {
		if (result.ok) {
			const resp = result.data;

			return {
				...result,
				data: resp
			};
		}
		return result;
	});

export const getSimulationParamsById = (params: any) =>
	get(`/GetSimulationInputParamsM6`, { params }).then((result: any) => {
		if (result.ok) {
			const resp = result.data;

			return {
				...result,
				data: resp
			};
		}
		return result;
	});

export const getBspLead = (id: any) =>
	getBsp(`/lead/${id}`, {}).then((result: any) => {
		if (result.ok) {
			const resp = result.data;

			return {
				...result,
				data: resp
			};
		}
		return result;
	});

export const getBspContact = (idLead: any) =>
	getBsp(`/lead/${idLead}/contractinfo`, {}).then((result: any) => {
		if (result.ok) {
			const resp = result.data;

			return {
				...result,
				data: resp
			};
		}
		return result;
	});

export const getBspTeam = (idTeam: any) =>
	getBsp(`/team/${idTeam}`, {}).then((result: any) => {
		if (result.ok) {
			const resp = result.data;

			return {
				...result,
				data: resp
			};
		}
		return result;
	});

export const getBspElec = (id: any) =>
	getBsp(`/elec/${id}`, {}).then((result: any) => {
		if (result.ok) {
			const resp = result.data;

			return {
				...result,
				data: resp
			};
		}
		return result;
	});

export const getBspGas = (id: any) =>
	getBsp(`/gas/${id}`, {}).then((result: any) => {
		if (result.ok) {
			const resp = result.data;

			return {
				...result,
				data: resp
			};
		}
		return result;
	});


export const updateBspLead = (id: any, lead: any) =>
	putBsp(`/lead/${id}`, { data: lead }).then((result: any) => {
		if (result.ok) {
			const resp = result.data;

			return {
				...result,
				data: resp
			};
		}
		return result;
	});

export const updateBspElec = (id: any, lead: any) =>
	putBsp(`/elec/${id}`, { data: lead }).then((result: any) => {
		if (result.ok) {
			const resp = result.data;

			return {
				...result,
				data: resp
			};
		}
		return result;
	});

export const createBspElec = (elecToCreate: any) =>
	postBsp(`/elec/new`, { data: elecToCreate }).then((result: any) => {
		//console.log('*******elec to**********')
		if (result.ok) {
			const resp = result.data;

			return {
				...result,
				data: resp
			};
		}
		return result;
	});

export const updateBspGas = (id: any, lead: any) =>
	putBsp(`/gas/${id}`, { data: lead }).then((result: any) => {
		if (result.ok) {
			const resp = result.data;

			return {
				...result,
				data: resp
			};
		}
		return result;
	});

export const createBspGas = (gasToCreate: any) =>
	postBsp(`/gas/new`, { data: gasToCreate }).then((result: any) => {
		//console.log('*******gas to**********', result)
		if (result.ok) {
			const resp = result.data;

			return {
				...result,
				data: resp
			};
		}
		return result;
	});

export const deleteBspGas = (id: any) =>
	deleteBsp(`/gas/${id}`, {}).then((result: any) => {
		//console.log('*******gas to**********', result)
		if (result.ok) {
			const resp = result.data;

			return {
				...result,
				data: resp
			};
		}
		return result;
	});

export const deleteBspElec = (id: any) =>
	deleteBsp(`/gas/${id}`, {}).then((result: any) => {
		//console.log('*******gas to**********', result)
		if (result.ok) {
			const resp = result.data;

			return {
				...result,
				data: resp
			};
		}
		return result;
	});

export const getStreetAddresses = (postCode: string) =>
	postEndpoints(`/api/getStreetsByPostCode`,
		{
			data: {
				postCode
			}
		}
	).then((result: any) => {
		if (result && result.ok === true) {
			const response = result.data;

			return {
				...result,
				ok: result.ok,
				message: result.message,
				data: response
			};
		}

		return {
			...result,
			ok: result.ok,
			message: _.get(result, "message.message", ""),
			data: []
		};
	});

export const cacheContracts = (requestData: any) =>
	postEndpoints(
		`${_.get(envConfig.publicRuntimeConfig, "expressApiUrl", "")}/contracts`,
		{
			data: requestData,
			headers: {
				'Authorization': `Basic ${Buffer.from('one-user-access:OctaPlus_1800!').toString('base64')}`
			},
			withCredentials: true
		}
	).then((result: any) => {
		if (result && result.ok === true) {
			const response = result.data;

			return {
				...result,
				ok: response.ok,
				message: response.message,
				data: response.data
			};
		}

		return {
			...result,
			ok: result.ok,
			message: _.get(result, "message.message", ""),
			data: {}
		};
	});


const logCurrentUser = async (requestData: any) => {
	return post('/api/prismaLogUser', {
		data: requestData,
	}).then((result: any) => {
		if (result.ok) {
			const resp = result;

			//console.log("resp", resp);
		}

		return result;
	});
}


export default {
	getCurrentIp,
	getCustomerLanguage,
	getMandateInfo,
	createContractEG,
	getSubscriptionId,
	getCompanyTypes,
	getGeneralConditions,
	getStreetAddresses,
	cacheContracts,
	logCurrentUser
};
